import { Component, OnInit, Input, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserService } from './user.service';
import { GlobalErrorHandler } from '../shared/core/error-handler';
import { NotificationsService, Notification } from '../shared/helper-components/index';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'user-menu',
  standalone: false,
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.css'],
})
export class UserMenuComponent implements OnInit {
  @ViewChild('userMenuDialog', { static: true }) userMenuDialog: TemplateRef<any>;
  private dialogRef: MatDialogRef<any>;
  userAction: string = "Resend";
  menuForm : FormGroup;
  @Input() userEmail: string;
  @Input() clientX;
  @Input() clientY;
  @Input() userStatus: string;
  resendVisible: boolean = true;
  extendVisible: boolean = true;

  constructor(
    private fb: FormBuilder,
    private _userService: UserService,
    private _errorHandler: GlobalErrorHandler,
    private _notificationsService: NotificationsService,
    private _dialog: MatDialog
  ){
    
  }

  private refreshVisibility(): string {
    var height = "80px";
    this.resendVisible = false;
    this.extendVisible = false;

    if (this.userStatus=="Pending"){
      this.resendVisible=true;
      height = "45px";
    }
    if (this.userStatus=="Inactive"){
      this.extendVisible=true;
      height = "45px";
    }
    return height;
  }
 
  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    if (!this.menuForm){
      this.menuForm = this.fb.group({
        userAction: '',
      });
    }
    this.userAction = "Resend";
  }

  closeMenu(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  changeOptionUserMenu(action: string){
    this.userAction = action;
  }

  resend(){
    this._userService.resendUser(this.userEmail)
    .subscribe( (success: any) => {
      if (!success){
        this._notificationsService.add(new Notification('error', `Something went wrong trying to resend email notification`));
      }
      else{
        this._notificationsService.add(new Notification('success', `User ${this.userEmail} will receive a new email notification`));
      }
    },
    (error: any)=>{
      this._errorHandler.processError(error);
    });
    this.closeMenu();
  }

  extend(){
    this._userService.extendUser(this.userEmail)
    .subscribe( (success: any) => {
      if (!success){
        this._notificationsService.add(new Notification('error', `Something went wrong trying to extend user validity`));
      }
      else{
        this._notificationsService.add(new Notification('success', `User validity of ${this.userEmail} will be extended`));
      }
    },
    (error: any)=>{
      this._errorHandler.processError(error);
    });
    this.closeMenu();
  }

  openMenu(clientX?: string, clientY?: string, userEmail?: string, userStatus?: string): void {
    if (userEmail !== undefined) {
      this.userEmail = userEmail;
    }
    if (userStatus !== undefined) {
      this.userStatus = userStatus;
    }

    if (this.dialogRef) {
      this.dialogRef.close();
    }

    this.refreshVisibility();
    const positionX = clientX !== undefined ? clientX : this.clientX;
    const positionY = clientY !== undefined ? clientY : this.clientY;

    this.dialogRef = this._dialog.open(this.userMenuDialog, {
      disableClose: false,
      width: '200px',
      minWidth: '200px',
      maxWidth: '200px',
      hasBackdrop: true,
      panelClass: 'users-menu-dialog',
      position: {
        top: `${this.extractPx(positionY)}px`,
        left: `${this.extractPx(positionX)}px`
      }
    });
  }

  private extractPx(value: string): number {
    if (!value) {
      return 0;
    }
    return Number(String(value).replace('px', '').replace('!Important', '').trim());
  }

}